module.exports = __webpack_public_path__ + "img/intro7.73d000fc.jpg";